import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/views/Dashboard.vue';
import PeriodicalResult from '@/views/periodical/PeriodicalResult.vue';
import HgFarmerResult from '@/views/hg-farmer/HgFarmerResult.vue';
import ClosestPopulationsResult from '@/views/closest-populations/ClosestPopulationsResult.vue';
import NotableIndividualResult from '@/views/notable-individuals/NotableIndividualResult.vue';
import GeneticSimilaritiesResult from '@/views/genetic-similarities/GeneticSimilaritiesResult.vue'
import PcaPlotResult from '@/views/pca-plots/PcaPlotResult.vue';
import SampleDatabase from '@/views/sample-database/SampleDatabase.vue';
import CriticalErrorPage from '@/components/ui/CriticalErrorPage.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/periodical',
      name: 'periodical',
      component: PeriodicalResult
    },
    {
      path: '/hg-farmer',
      name: 'hg-farmer',
      component: HgFarmerResult
    },
    {
      path: '/closest-populations',
      name: 'closest-populations',
      component: ClosestPopulationsResult
    },
    {
      path: '/notable-individuals',
      name: 'notable-individuals',
      component: NotableIndividualResult
    },
    {
      path: '/genetic-similarities',
      name: 'genetic-similarities',
      component: GeneticSimilaritiesResult
    },
    
    {
      path: '/pca-plot',
      name: 'pca-plot',
      component: PcaPlotResult
    },

    {
      path: '/sample-database',
      name: 'sample-database',
      component: SampleDatabase
    },    
    {
      path: '/error-page',
      name: 'error-page',
      component: CriticalErrorPage
    },
  ]
});
